import React from "react"
import ReactDOM from "react-dom"
import MerchantPageMapSection from "./merchant-page-map-section"

export default class MerchantPageMapSectionModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.currentPageJson = elem.dataset.currentPageJson && JSON.parse(elem.dataset.currentPageJson)
    self.hideMap = elem.dataset.hideMap
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MerchantPageMapSection {...self.modelJson} {...self.currentPageJson} globalHideMap={self.hideMap === "True"} />, self.elem)
  }
}
